module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-timeline"
  }, [_c('flash-swf', {
    attrs: {
      "attributes": _vm.attr,
      "flashvars": _vm.flashvars
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51a5f506","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActionTimeline/ActionTimeline.vue
// module id = 390
// module chunks = 0